<template>
    <div>

    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {

    components: {
    },
    computed: {
        ...mapGetters({
            currentLanguage: 'base/currentLanguage'
        }),
    },
    methods: {
    },
    mounted() {
        this.vuexFromStorage("base/currentLanguage")
        let currentLanguage = this.storageLoad("base/currentLanguage")
        if (!currentLanguage) {
            this.storageSave("base/currentLanguage", window.navigator.language);
            this.vuexFromStorage("base/currentLanguage")
        }
        if(currentLanguage.toLowerCase() == 'id')
        {
            this.$router.push('/id/home');
        }
        else if(currentLanguage.toLowerCase() == 'en-us')
        {
            this.$router.push('/en-us/home');
        }
        else if(currentLanguage.toLowerCase() == 'ja')
        {
            this.$router.push('/ja/home');
        }


        // this.toast(this.currentLanguage)

    }
}
</script>